// ----------------------------------------------------------------------

const account = {
  displayName: 'Solciviles S.A.',
  email: 'demo@minimals.cc',
  // photoURL: ' assets/logo.png',
};

export default account;
